module.exports = __webpack_public_path__ + "static/media/step1.fd915d72.png";